// Asset Table - English
export default {
  loading: { text: "Loading..." },
  table: {
    totalPrefix: "Total",
    totalSuffix: "records",
    download: "Download",
    empty: "No data",
    asset: "Asset",
    quantity: "Quantity",
    priceUSDT: "Price (USDT)",
    valueUSDT: "Value (USDT)",
  },
  tooltips: {
    price:
      "Token price is the token's corresponding USDT price; price data updates daily",
    value:
      "Token value is calculated from the token price and fluctuates with many factors; for reference only",
  },
  labels: {
    updatedTimePrefix: "Updated time: ",
  },
  bigAddress: {
    empty:
      "This address has too much transaction data; only queries with sender/receiver address conditions are supported",
  },
  downloadFileName: "Data Details",
};
